import { type SvgProps, SvgWrapper } from '../utils';

export function JordskifterettIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <circle cx="12" cy="12" r="6" />
    </SvgWrapper>
  );
}
